import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { formHelpers } from '../utils/helpers';

const remoteIdProp = 'remote_id';

export const useAccountingOptions = () => {
  const { expenseCategories, costCenters, listItems, locations, numberingFlows, taxCodes } = useSelector(state => state.accounting);
  const vendors = useSelector(state => state.vendor.vendors);

  const useCreateOptions = (data, props) => useMemo(
    () => formHelpers.formatSelectOptions({ data, ...props }),
    [data, props]
  );

  return {
    expenseCategoryOptions: useCreateOptions(expenseCategories, {  valueProp: remoteIdProp, labelProp: [remoteIdProp, 'account_name'] }),
    departmentOptions: useCreateOptions(costCenters, { valueProp: remoteIdProp, labelProp: [remoteIdProp, 'name'] }),
    listItemOptions: useCreateOptions(listItems, { valueProp: remoteIdProp, labelProp: [remoteIdProp, 'name'] }),
    locationOptions: useCreateOptions(locations, { valueProp: remoteIdProp, labelProp: [remoteIdProp, 'name'] }),
    numberingFlowsOptions: useCreateOptions(numberingFlows, { valueProp: remoteIdProp, labelProp: [remoteIdProp, 'name'] }),
    taxCodeOptions: useCreateOptions(taxCodes, { valueProp: remoteIdProp, labelProp: [remoteIdProp, 'name'] }),
    vendorOptions: useCreateOptions(vendors, { filteredPropName: 'accounting_external_reference', valueProp: 'vendor_id' }),
  };
};
